import { UserAvatar } from '@features/user/ui/UserAvatar/UserAvatar';

import styles from './UserMiniCard.module.css';

type Props = {
  user?: {
    firstName: string;
    lastName: string;
  };
};
export function UserMiniCard({ user }: Props) {
  if (!user) return null;

  return (
    <div className={styles.userMiniCard}>
      <UserAvatar size="36" user={user} />
      <div className={styles.nameContainer}>
        <div className={styles.name}>{user.lastName}</div>
        <div className={styles.name}>{user.firstName}</div>
      </div>
    </div>
  );
}
